import { trendingArticles } from '@/mocks/articles';

export interface ArticleDetail {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  imageUrl: string;
  heat: number;
  date: string;
  readTime: string;
  tags: string[];
  author: string;
  source: string;
  content: string;
}

export function getArticleById(id: number): ArticleDetail | undefined {
  const base = trendingArticles.find((a) => a.id === id);
  if (!base) return undefined;
  return articleDetailsMap[id] || undefined;
}

const articleDetailsMap: Record<number, ArticleDetail> = {
  1: {
    ...trendingArticles[0],
    author: '911爆料编辑部',
    source: '实地追踪',
    content: `
<p>近日，有网友在短视频平台刷直播时意外发现，四川省甘孜州理塘县的丁真珍珠竟出现在某知名网红的直播间中。据悉，该网红正在举行一场名为"高原探秘"的带货直播，而丁真的现身本应是当天的最大亮点。</p>

<p>然而让所有人意外的是，整场直播中丁真全程表情严肃，几乎没有任何互动。当网红试图拉他一起喊口号、做游戏时，丁真更是直接摇头拒绝，现场气氛一度十分尴尬。</p>

<blockquote>
  <p>"我就看到丁真坐在那里，表情很冷，完全不像平时那个笑起来阳光灿烂的少年。网红在旁边又蹦又跳，他连看都不看一眼。"一位观看直播的网友这样描述当时的情景。</p>
</blockquote>

<p>丁真珍珠自2020年凭借一段纯真笑容的短视频走红以来，一直以阳光、质朴的形象深受大众喜爱。他不仅成为了理塘县的旅游形象大使，更是多次登上央视舞台，成为少数民族青年的代表人物。</p>

<p>然而随着知名度的提升，丁真也面临着越来越多的商业合作邀约。据知情人士透露，丁真的团队对于商业合作有着严格的标准，并非所有的合作都会接受。而这次出现在该网红的直播间，很可能是经纪团队在合同压力下做出的妥协。</p>

<p>事后，该网红在社交平台发布了与丁真的合照，并配文"谢谢丁真小哥哥的捧场"。但评论区却出现了大量质疑的声音，有粉丝直接指出"丁真全程黑脸，你还真好意思发"。</p>

<p>截至目前，丁真方面尚未对此事做出任何回应。我们也将持续关注此事的最新进展。</p>
`,
  },
  2: {
    ...trendingArticles[1],
    author: '深度调查组',
    source: '多方证实',
    content: `
<p>娱乐圈"耍大牌"又添新料。近日，多位来自同一剧组的幕后工作人员在网上匿名发声，联合爆料某当红男演员在拍摄期间的种种不当行为，引发业内外广泛关注。</p>

<p>据多位爆料者描述，这位男演员的"耍大牌"行为几乎贯穿了整个拍摄周期。从开机仪式迟到两小时，到拍摄现场临时要求修改剧本，再到对化妆师、服装师的态度恶劣——每一条爆料都直指这位演员的职业素养问题。</p>

<blockquote>
  <p>"全组几百号人就等他一个人。场务、灯光、摄像全部就位，导演在对讲机里喊了三遍，他还在房车里打游戏。这种事情发生了不止一次，几乎每天都是这样。"一位自称是剧组灯光师的工作人员在社交平台写道。</p>
</blockquote>

<p>更让人震惊的是，该演员甚至连最基本的台词准备都不愿意做。据一位跟组编剧透露，该演员经常在拍摄现场让助理拿着提词板，自己照着念，导致NG次数过多，严重拖慢了拍摄进度。</p>

<p>另一位剧组工作人员补充说："他对化妆师和服装师的态度特别差。有一次化妆师不小心碰了一下他的头发，他当场就发飙了，骂得特别难听。那个化妆师是女生，当场就哭了。"</p>

<p>虽然爆料者没有直接点出该男演员的姓名，但通过"当红顶流""正在横店拍摄""近期有大制作古装剧"等关键信息，网友很快锁定了几个可能的对象。</p>

<p>截至发稿，相关方面尚未对此做出正式回应。</p>
`,
  },
  3: {
    ...trendingArticles[2],
    author: '911爆料编辑部',
    source: '社交平台证实',
    content: `
<p>娱乐圈的分分合合总是牵动着千万粉丝的心。就在昨天深夜，知名网红情侣"糖果夫妇"（网名）突然在各自的社交账号上同步发布分手声明，这段持续三年的恋情宣告终结。</p>

<p>男方发布的声明写道："感谢大家一路以来的关注和支持。经过慎重考虑，我们决定和平分开。这三年的时光将永远是我人生中最宝贵的回忆。"女方的声明措辞几乎一致，两人的默契程度让人不禁唏嘘。</p>

<blockquote>
  <p>"卡点同一分钟发的，文案几乎一模一样。就连分手都能这么有默契，为什么要分开啊？"一位粉丝在评论区写道，这条评论获得了超过10万点赞。</p>
</blockquote>

<p>然而，眼尖的网友很快发现了一些不寻常的细节。在分手声明发布前三天，男方曾在深夜发了一条动态"人心是会变的"，随后秒删。而女方则在同一时间段取关了男方的好几位好友。</p>

<p>更重磅的是，有知情网友爆料称，最近频繁出现在男方直播间的某位新晋女网红，与男方的关系非同寻常。该网友贴出了多张两人在私下约会的照片，时间线显示这些约会发生在与女方分手之前。</p>

<p>"所以根本不是和平分手，是出轨实锤啊！"网友们纷纷表示愤怒，短时间内#糖男出轨#的话题就冲上了热搜榜首。</p>

<p>目前，男女双方均已关闭了评论区，但相关话题仍在持续发酵中。</p>
`,
  },
  4: {
    ...trendingArticles[3],
    author: '911爆料编辑部',
    source: '综合报道',
    content: `
<p>深夜的一纸道歉声明将某位顶流女星重新推上了舆论的风口浪尖。昨晚23时许，该女星通过个人社交账号发布了一篇长达千字的道歉长文，就近期被媒体曝光的税务问题向公众致歉。</p>

<p>在道歉声明中，该女星承认了自己在税务方面存在的疏漏，称"由于个人对税务政策的理解不足，导致了此次问题的发生"。她同时表示已经主动配合相关部门的调查，并补缴了全部税款及滞纳金。</p>

<blockquote>
  <p>"作为公众人物，我应该更加严格地要求自己。这次的事件给我敲响了警钟，我将以此为戒，在今后的工作和生活中更加谨慎。"该女星在道歉信中写道。</p>
</blockquote>

<p>然而，这份道歉声明并没有获得所有网友的谅解。有法律界人士指出，根据目前公开的信息，该女星涉及的税务问题可能不仅仅是"理解不足"那么简单，而是涉及到了更为复杂的税务筹划和避税手段。</p>

<p>据接近该女星团队的消息人士透露，此次税务问题的导火索是其名下一家影视文化公司的账目异常。该公司在两年内申报了大量与实际业务不符的支出，涉嫌虚增成本以降低应纳税所得额。</p>

<p>该女星的商业代言也受到了影响。已有至少三个品牌在事件曝光后紧急撤下了与其相关的宣传物料，其中还包括一个刚刚签约不到一个月的国际美妆品牌。</p>

<p>"这次的影响肯定比表面上看起来严重得多。品牌方的反应速度说明了一切。"一位不愿具名的公关从业者这样评价。</p>
`,
  },
  5: {
    ...trendingArticles[4],
    author: '深度调查组',
    source: '平台确认',
    content: `
<p>拥有超过5000万粉丝的短视频平台超级网红，正面临着职业生涯中最严峻的挑战。据多个消息源证实，该网红因涉嫌多起虚假宣传事件，已被大量用户联合举报至平台和监管部门。</p>

<p>据悉，引发此次大规模举报的导火索是该网红近期推广的一款所谓"进口高端面膜"。有多位购买者反映，该面膜使用后出现了不同程度的过敏反应，且经专业人士鉴定，该产品使用的成分与宣传严重不符。</p>

<blockquote>
  <p>"花了几百块买的面膜，用了两次脸就红肿了。去找客服连消息都不回。这种网红带货的产品，真的不能随便相信。"一位受害消费者对记者表示。</p>
</blockquote>

<p>但这并非个例。记者调查发现，仅在过去半年内，该网红就至少涉及三起类似的虚假宣传事件。其中包括夸大某保健品功效、虚假标称某服装品牌为"国际大牌"、以及为某涉嫌传销的微商平台进行宣传等。</p>

<p>根据《中华人民共和国广告法》和《网络直播营销管理办法（试行）》的相关规定，主播在直播带货过程中对商品进行虚假或引人误解的宣传，将面临行政处罚，情节严重的还可能构成刑事犯罪。</p>

<p>目前，短视频平台已对该网红的账号进行了"限制推荐"处理，并表示正在对举报内容进行核实。如果最终认定违规行为属实，该账号可能面临从限流到永久封禁不等的处罚。</p>
`,
  },
  6: {
    ...trendingArticles[5],
    author: '911爆料编辑部',
    source: '工作室声明',
    content: `
<p>近日，某知名男星的个人隐私信息在网络上被恶意传播，引发了舆论的强烈关注。据悉，被泄露的信息包括该男星的个人联系方式、家庭成员信息，甚至还包括其私人行程安排等高度敏感的内容。</p>

<p>事件发生后，该男星的工作室反应迅速，在第一时间发布了措辞严厉的律师函，要求相关平台立即删除侵权内容，并表示将追究信息泄露者和恶意传播者的法律责任。</p>

<blockquote>
  <p>"我们严正声明：任何未经授权获取、传播艺人个人信息的行为，都是对公民隐私权的严重侵犯。我们将不惜一切代价，采取全部法律手段维护艺人的合法权益。"律师函中这样写道。</p>
</blockquote>

<p>事实上，这已经不是娱乐圈第一次发生明星隐私泄露事件。在此前的多起类似事件中，泄露源头往往指向了与艺人工作有直接关联的"内鬼"——经纪公司员工、合作方工作人员、甚至是粉丝后援会的核心成员。</p>

<p>记者注意到，在此次被泄露的信息中，有一部分内容来自微信聊天记录的截图，这意味着信息泄露可能来自于该男星身边较为亲近的工作人员或朋友。</p>

<p>目前，多个传播侵权内容的账号已经被平台封禁处理。有关部门也已经介入调查，力求尽快锁定信息泄露的源头。</p>

<p>在此也提醒广大网友：传播他人隐私信息属于违法行为，请勿参与此类信息的转发和讨论。</p>
`,
  },
  7: {
    ...trendingArticles[6],
    author: '911爆料编辑部',
    source: '现场直击',
    content: `
<p>综艺节目录制中的意外事件总是最引人注目的。昨日下午，某热门综艺节目在浙江某影视基地录制时突发意外状况，导演组不得不紧急叫停录制。</p>

<p>据现场观众爆料，事发时正在进行一个大型户外挑战环节，有数名嘉宾参与到一项较为危险的体能竞技当中。在其中一名嘉宾完成挑战后不久，突发身体不适，出现了头晕、恶心等症状，现场医疗团队随即介入。</p>

<blockquote>
  <p>"当时大家都吓坏了。我看到那个嘉宾脸色发白，然后就坐在地上了。工作人员很快围了上去，导演在对讲机里喊'停停停，全部停下来'。"一位在现场的观众向记者回忆道。</p>
</blockquote>

<p>经过现场医护人员的紧急处理，该嘉宾的状况逐渐稳定，并于随后被送往附近医院进行进一步检查。据医院方面透露，该嘉宾的情况并不严重，主要是由于高强度运动加上当天高温天气导致的轻度中暑。</p>

<p>节目组随后发布了一份简短的声明，确认了录制中出现的意外状况，并对受到影响的嘉宾和观众表达了歉意。声明中强调，节目组一直将嘉宾和工作人员的安全放在首位，后续将进一步加强现场安全管理。</p>

<p>据悉，该期节目的录制将在下周择日恢复进行。而这次的意外事件是否会影响到该节目的播出档期，目前尚无确切消息。</p>
`,
  },
  8: {
    ...trendingArticles[7],
    author: '深度调查组',
    source: '独家调查',
    content: `
<p>选秀节目的"暗箱操作"历来是娱乐圈最具争议的话题之一。近日，本网调查记者经过长达三个月的深入追踪，揭开了一条隐藏在选秀节目背后的投票造假灰色产业链，其规模之大、手段之成熟，令人瞠目结舌。</p>

<p>调查发现，这条产业链涉及多个环节：有专门开发投票刷票软件的技术团队、有负责大量收购手机号卡用于注册投票账号的号商、有提供自动化投票设备（俗称"手机墙"）的硬件供应商，甚至还有专门对接粉丝后援会、提供"一站式打投服务"的中间人。</p>

<blockquote>
  <p>"一台设备可以同时控制几百个账号进行投票。只要你出得起钱，想让谁的票数第一，谁就是第一。"一位曾经从业的知情者向记者透露。</p>
</blockquote>

<p>记者以某粉丝后援会工作人员的身份接触到了一家名为"星辰数据"的投票服务公司。该公司销售人员毫不避讳地介绍了他们的业务："普通的短信投票10万票起做，App内投票要看平台的风控难度，稍微贵一点。如果你们预算够的话，我们还可以提供'真人打投'服务，就是用真实手机号加真人操作，平台很难检测出来。"</p>

<p>根据记者获取的报价单，一场中等规模的选秀节目决赛，如果想要将某位选手从十名开外"做"进前三，至少需要投入300万到500万元。而这笔费用通常由粉丝后援会通过集资方式筹集。</p>

<p>法律专家指出，这种有组织的投票造假行为涉嫌多项违法，包括破坏计算机信息系统罪、非法获取计算机信息系统数据罪等。而粉丝集资的行为如果缺乏有效的监管，也存在被挪用的风险。</p>
`,
  },
};